
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75 1a.75.75 0 00-1.5 0h1.5zm-6 0a.75.75 0 00-1.5 0h1.5zm4.5 16a.75.75 0 001.5 0h-1.5zm7.5-16a.75.75 0 00-1.5 0h1.5zM2.25 17a.75.75 0 001.5 0h-1.5zm12 0a.75.75 0 001.5 0h-1.5zM9.75 3V1h-1.5v2h1.5zm-5.5 10c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 005.75 13h-1.5zM3 14.25c-.69 0-1.25-.56-1.25-1.25H.25A2.75 2.75 0 003 15.75v-1.5zM1.75 13c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 00.25 13h1.5zM3 11.75c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 003 10.25v1.5zM10.25 5c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0011.75 5h-1.5zM9 6.25c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 009 7.75v-1.5zM7.75 5c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 006.25 5h1.5zM9 3.75c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 009 2.25v1.5zM16.25 13c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0017.75 13h-1.5zM15 14.25c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0015 15.75v-1.5zM13.75 13c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0012.25 13h1.5zM15 11.75c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0015 10.25v1.5zM3.75 11V1h-1.5v10h1.5zm6 6V7h-1.5v10h1.5zm6-6V1h-1.5v10h1.5zm-12 6v-2h-1.5v2h1.5zm12 0v-2h-1.5v2h1.5z"}})])
          )
        }
      }
    